var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab flex_v",class:{ selected: _vm.selected && _vm.$store.state.navigationStyle == 1, business: _vm.selected && _vm.$store.state.navigationStyle == 2 }},[_c('img',{attrs:{"src":_vm.img}}),_c('h5',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }